import { forwardRef } from 'react';
import { Alert } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { closeSnackbar } from 'notistack';
import type { TpPushAlert } from './usePushAlert';

type PpCustomSnackbar = Pick<TpPushAlert, 'dismissable' | 'message' | 'severity'> & {
  id: string;
};

export const AlertSnackbar = forwardRef<HTMLDivElement, PpCustomSnackbar>(
  ({ dismissable, id, message, severity }, ref) => {
    const theme = useTheme();

    const dismissableAlertStyle = {
      '.MuiAlert-icon': {
        marginTop: theme.spacing(0.5),
      },
    };

    return (
      <div ref={ref} role="alert">
        <Alert
          data-qa={id}
          severity={severity}
          sx={dismissable ? dismissableAlertStyle : null}
          onClose={
            dismissable
              ? (): void => {
                  closeSnackbar(id);
                }
              : undefined
          }
        >
          {message}
        </Alert>
      </div>
    );
  },
);
AlertSnackbar.displayName = AlertSnackbar.name;
